<template>
	<div>
		<bsh-datatable
			:columns="columns"
            :buttons="buttons"
			:link="$url+'/api/adm/pedidos/pagamentos/'+$route.params.id"
            actionFild
            @update="update"
            @destroy="destroy"
			sorting>
		</bsh-datatable>
	</div>
</template>

<script>
export default {
    props: ['date'],
	data(){
		return {
            searchDate: '',
            columns: [
                {
                    label: '#',
                    field: 'id',
                    order: 'receita.id',
                    sort: 'asc'
                },
                {
                    label: 'Data Pagamento',
                    field: 'data_br',
                    order: 'receita.data',
                    noSorting: true
                },
                {
                    label: 'Forma de Pagamento',
                    field: 'forma_pagamento',
                    order: 'receita.forma_pagamento',
                    noSorting: true
                },
                {
                    label: 'Valor',
                    field: 'valor_br',
                    order: 'receita.valor',
                    sort: 'asc'
                }
            ],
            buttons: [
                {
                    action: 'update',
                    classe: 'btn btn-primary',
                    iconClass: 'fas fa-edit'
                },
                {
                    action: 'destroy',
                    classe: 'btn btn-danger',
                    iconClass: 'fas fa-trash'
                },
            ]
    	}
	},
    methods: {
        update(dado){
            this.$emit('update', dado.id);
        },
        destroy(dado){
            this.$emit('destroy', dado.id);
        }
    }
}
</script>
